export default "<app-game></app-game>\r\n"